const KujipySchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "MusicGroup",
    "@id": "https://www.kujipy.com/#musicgroup",
    name: "Kujipy",
    url: "https://www.kujipy.com/",
    description: "Agrupación de música de viento mixe de Santa María Tlahuitoltepec, Oaxaca.",
    genre: ["Música mixe", "Música de viento", "Música tradicional"],
    foundingLocation: { "@type": "Place", name: "Santa María Tlahuitoltepec, Oaxaca, México" },
    sameAs: ["https://www.youtube.com/@kujipyoficial8421", "https://www.facebook.com/kujipy", "https://open.spotify.com/artist/3tDuuuTkPprgYHtL7QsvXs", "https://www.instagram.com/kujipy"],
    contactPoint: { "@type": "ContactPoint", contactType: "booking", email: "kujipy.suun@gmail.com", availableLanguage: ["Spanish", "English"] }
  };
  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
};
export default KujipySchema;
